import type { RouteObject } from "react-router-dom";
import { productsRoutes } from "@/pages/haccp/products/routes";
import { technicalsheetsRoutes } from "@/pages/haccp/technicalsheets/routes";
import { pictureTraceabilityRoutes } from "@/pages/haccp/picture-traceability/routes";
import { processTemplateRoutes } from "@/pages/haccp/process-template/routes";
import { foodPreparationRoutes } from "@/pages/haccp/food-preparation/routes";

export const haccpRoutes: RouteObject[] = [
  ...pictureTraceabilityRoutes,
  ...productsRoutes,
  ...technicalsheetsRoutes,
  ...processTemplateRoutes,
  ...foodPreparationRoutes,
];
